import { createApiActionTypes } from '../../helpers/actions';


export const ANALYTICS_NEW_SESSION = createApiActionTypes('ANALYTICS_NEW_SESSION');
export const ANALYTICS_VIEW_TICKET = createApiActionTypes('ANALYTICS_VIEW_TICKET');
export const ANALYTICS_BUY_TICKET = createApiActionTypes('ANALYTICS_BUY_TICKET');
export const ANALYTICS_ACTION = createApiActionTypes('ANALYTICS_ACTION');

export const ANALYTICS_EVENT = 'meta/ANALYTICS_EVENT';
export const ANALYTICS_PAGEVIEW = 'meta/ANALYTICS_PAGEVIEW';



// WEBPACK FOOTER //
// ./src/actions/analytics/types.js